import MDSnackbar from "mdComponents/MDSnackbar";

interface NotificationAlertProps {
    open: boolean;
    close: boolean;
    onClose: () => void;
    color: "success" | "error" | "info" | "warning" | "primary" | "dark";
    icon?: string;
    title: string;
    content: string;
    dateTime: string;
}

const NotificationAlert = (props: NotificationAlertProps) => {
    const { open, close, onClose, icon, color, title, content, dateTime } = props;;
    
    return(
    <MDSnackbar
      color={color}
      icon={icon}
      title={title}
      content={content}
      dateTime={dateTime}
      open={open}
      onClose={onClose}
      close={onClose}
      bgWhite
    />
    );
};

export default NotificationAlert;